export default function IconAchtung () {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5ZM4.375 5.71648V1.87502H5.625V5.71648H4.375ZM4.375 7.98782V6.73782H5.625V7.98782H4.375Z"
            fill="#C11801"/>
    </svg>

  )
}
